"use client";

import { useState, useEffect } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Catalog() {
  const {
    ref: headingRef,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const [isZh, setIsZh] = useState(false);
  useEffect(() => {
    const checkLanguage = () => {
      setIsZh(localStorage.getItem("elite-language") === "zh-Hant");
    };
    checkLanguage();
    window.addEventListener("storage", checkLanguage);
    return () => window.removeEventListener("storage", checkLanguage);
  }, []);
  const categories = [{
    name: "Art & Craft Kits",
    nameZh: "美術及手工藝套裝",
    description: "Custom creative sets, DIY crafting bundles, and precision-manufactured art materials tailored for global brands.",
    descriptionZh: "為全球品牌度身訂造的創意套裝、DIY 手作組合及精準製造的美術材料。",
    route: "/art-craft-kits",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707169/img/plush_mascots.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707169/img/plush_mascots.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707169/img/plush_mascots.png-wvc-sizes",
    alt: "Assorted art and craft kit materials for custom manufacturing"
  }, {
    name: "Puzzles & Educational Games",
    nameZh: "拼圖及益智玩具",
    description: "High-grade board games, wooden puzzles, and cognitive learning activities built to international safety standards.",
    descriptionZh: "符合國際安全標準的高品質桌上遊戲、木製拼圖與啟發思維的益智學習教具。",
    route: "/puzzles-educational-games",
    image: "https://elite-corpltd.com/wp-content/uploads/2026/08/35b8a58d4832ac22.png?v=x1hjjuyj5xq",
    srcset: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/odm_product_puzzle_wildlife.png?v=j0fyxri7fre-wvc-srcset",
    sizes: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/odm_product_puzzle_wildlife.png?v=qdlgindhjcl-wvc-sizes",
    alt: "Wildlife-themed wooden educational puzzle"
  }, {
    name: "Collectible Figurines",
    nameZh: "收藏級公仔手辦",
    description: "Collector-grade injection molded plastic and PVC figurines engineered with detailed finishes and licensed IP fidelity.",
    descriptionZh: "採用精準注塑工藝及高級 PVC 製造，具備細緻塗裝與授權 IP 高還原度。",
    route: "/collectible-figurines",
    image: "https://elite-corpltd.com/wp-content/uploads/2026/09/PHOTO-2026-09-07-12-26-24.jpg?v=91vzum50em7",
    srcset: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/odm_product_figurines_garfield.png?v=w42cat1oeri-wvc-srcset",
    sizes: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/odm_product_figurines_garfield.png?v=g8xnsxctzzw-wvc-sizes",
    alt: "Collectible injection-molded figurine with detailed finish"
  }, {
    name: "Interactive Pet Toys",
    nameZh: "互動寵物玩具",
    description: "Durable electronic, plush, and sensory pet toys engineered for high engagement and certified product durability.",
    descriptionZh: "經耐用度認證的電子、毛絨及感官互動寵物玩具，提供高互動娛樂體驗。",
    route: "/interactive-pet-toys",
    image: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/odm_product_pet_toys.png?v=p2s9yfpuiy",
    srcset: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/odm_product_pet_toys.png?v=j4bt84bffxp-wvc-srcset",
    sizes: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/odm_product_pet_toys.png?v=0yxo1wdvfbff-wvc-sizes",
    alt: "Plush interactive pet toy"
  }, {
    name: "Toy Books & Learning Products",
    nameZh: "玩具書及早教產品",
    description: "Interactive sound books, tactile board books, and early childhood learning products manufactured with non-toxic materials.",
    descriptionZh: "採用無毒環保物料製造的有聲互動書、觸感布書及幼兒早教益智產品。",
    route: "/toy-books-learning-products",
    image: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/odm_product_toy_books.png?v=svgexg8igic",
    srcset: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/odm_product_toy_books.png?v=xgpg5jecj-wvc-srcset",
    sizes: "https://joint-gopher.10web.cloud/wp-content/uploads/2026/06/odm_product_toy_books.png?v=r8sbrngbgc-wvc-sizes",
    alt: "Illustrated children's toy book with tactile pages"
  }];
  return <section data-section-id="15959" id="odm-product-showcase" className="bg-background text-foreground py-32 md:py-44">
      <div className="mx-auto max-w-[1240px] px-5 md:px-8">
        <div ref={headingRef} className="mx-auto max-w-[680px] text-center transition-all duration-[620ms]" style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(16px)",
        transitionTimingFunction: "cubic-bezier(0.22, 0.61, 0.36, 1)"
      }}>
          <div className="flex items-center justify-center gap-3">
            <span className="font-default text-xs font-semibold uppercase text-foreground" style={{
            letterSpacing: "0.16em"
          }}>
              {isZh ? "OEM & ODM 解決方案" : "OEM & ODM Solutions"}
            </span>
            <span className="h-px bg-primary transition-all duration-[520ms]" style={{
            width: isVisible ? "48px" : "0px",
            transitionTimingFunction: "cubic-bezier(0.22, 0.61, 0.36, 1)",
            transitionDelay: "200ms"
          }} />
          </div>
          <h2 className="mt-6 font-default text-foreground" style={{
          fontSize: "clamp(2rem, 3.6vw, 3.5rem)",
          fontWeight: 600,
          letterSpacing: "-0.018em",
          lineHeight: 1.08
        }}>
            {isZh ? "產品分類" : "Product Categories"}
          </h2>
          <p className="mx-auto mt-6 font-default text-muted-foreground" style={{
          fontSize: "clamp(1.0625rem, 1.15vw, 1.1875rem)",
          fontWeight: 400,
          letterSpacing: "-0.005em",
          lineHeight: 1.6
        }}>
            {isZh ? "我們為國際消費品牌工程研發並製造一站式 OEM 及 ODM 玩具解決方案，融合工業設計、高產能雙工廠生產與國際合規檢測。" : "We engineer and manufacture turnkey OEM and ODM toy solutions for international consumer brands, combining industrial design, high-capacity dual-factory production, and international compliance testing."}
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
          {categories.map((category, i) => <div key={category.name} data-index={i} className="group flex flex-col overflow-hidden border border-border bg-card transition-all duration-[240ms] ease-out hover:-translate-y-1 hover:border-primary">
              <div className="aspect-[4/3] overflow-hidden bg-muted">
                <img src={category.image} data-wvc-srcset={category.srcset} data-wvc-sizes={category.sizes} alt={category.alt} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-[600ms] ease-out group-hover:scale-[1.03]" />
              </div>
              <div className="flex flex-1 flex-col p-6 md:p-8">
                <h3 className="font-default text-foreground" style={{
              fontSize: "clamp(1.25rem, 1.5vw, 1.5rem)",
              fontWeight: 600,
              letterSpacing: "-0.01em",
              lineHeight: 1.25
            }}>
                  {isZh ? category.nameZh : category.name}
                </h3>
                <p className="mt-3 flex-1 font-default text-muted-foreground" style={{
              fontSize: "0.9375rem",
              fontWeight: 400,
              letterSpacing: "-0.005em",
              lineHeight: 1.55
            }}>
                  {isZh ? category.descriptionZh : category.description}
                </p>
                <div className="mt-6 pt-2">
                  <Button asChild variant="outline" className="w-full border-border bg-transparent font-default text-sm font-semibold text-foreground transition-colors hover:border-primary hover:bg-primary hover:text-primary-foreground">
                    <Link to={category.route}>
                      {isZh ? "查看詳情" : "View Details"}
                    </Link>
                  </Button>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}